'use client'
import { useState } from "react";
import Link from "next/link";
import axios from "axios";
import { Dropdown } from 'primereact/dropdown';
import Button from "@/ui/button";
import Checkbox from "@/ui/checkbox";
import cl from "clsx";

import styles from './styles.module.css';
import './contact-form.css';

export default function ContactForm({ dict }) {
    // Destructure the needed text from dict.contactForm
    const {
        placeholders,
        questionTypePlaceholder,
        questionOptions,
        checkboxLabelMobile,
        termsAndConditions,
        checkboxLabelDesktop,
        privacyPolicy,
        buttonText,
        alertNotChecked,
        successMessage,
        errorMessage,
        errorAlert
    } = dict.contactForm;

    const [name, setName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [email, setEmail] = useState('');
    const [questionType, setQuestionType] = useState('');
    const [isChecked, setIsChecked] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        const apiUrl = (process.env.NEXT_PUBLIC_API_URL || '').replace(/\/$/, '');

        if (!isChecked) {
            alert(alertNotChecked);
            return;
        }

        try {
            const response = await axios.post(
                `${apiUrl}/api/base/contact/`,
                {
                    name,
                    email,
                    phone: phoneNumber,
                    question_type: questionType,
                    comment: ''
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        accept: 'application/json'
                    }
                }
            );

            if (response.status === 200) {
                alert(successMessage);
                setName('');
                setPhoneNumber('');
                setEmail('');
                setQuestionType('');
                setIsChecked(false);
            } else {
                alert(errorMessage);
            }
        } catch (error) {
            console.error("Error sending message:", error);
            alert(errorAlert);
        }
    };

    return (
        <form className={cl(styles.contact_form, 'contact_form')} onSubmit={handleSubmit}>
            <div className={styles.contact_form_wrapper}>
                <input
                    id="name"
                    className={styles.contact_form__input}
                    type="text"
                    placeholder={placeholders.name}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                />

                <input
                    id="phone"
                    className={styles.contact_form__input}
                    type="tel"
                    placeholder={placeholders.phone}
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    required
                />

                <input
                    id="email"
                    className={styles.contact_form__input}
                    type="email"
                    placeholder={placeholders.email}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />

                <Dropdown
                    id="question-type"
                    value={questionType}
                    options={questionOptions}
                    onChange={(e) => setQuestionType(e.value)}
                    placeholder={questionTypePlaceholder}
                />

                {/* Mobile checkbox block */}
                <div className={styles.contact_form__checkbox_block_mobile}>
                    <Checkbox
                        checked={isChecked}
                        onChange={() => setIsChecked(!isChecked)}
                    />
                    <label htmlFor="contact-form-checkbox">
                        {checkboxLabelMobile}
                        <Link href="#" className={styles.contact_form__link}>
                            {termsAndConditions}
                        </Link>.
                    </label>
                </div>

                <div className={styles.contact_form__button_wrapper}>
                    <Button typeButton="submit" type="submit" title={buttonText} />
                </div>
            </div>

            {/* Desktop checkbox block */}
            <div className={styles.contact_form__checkbox_block}>
                <Checkbox
                    checked={isChecked}
                    onChange={() => setIsChecked(!isChecked)}
                />
                <label htmlFor="contact-form-checkbox">
                    {checkboxLabelDesktop}
                    <Link
                        href="https://ic-ces.at/impressum/"
                        target="_blank"
                        className={styles.contact_form__link}
                    >
                        {privacyPolicy}
                    </Link>
                </label>
            </div>
        </form>
    );
}
